<router-outlet></router-outlet>

<!-- @if(layoutService.loading) {
    <app-loader></app-loader>
} -->

<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple">
 <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>

<app-back-to-top></app-back-to-top>